import { render, staticRenderFns } from "./BarcodeTest.vue?vue&type=template&id=768ee241&scoped=true&"
import script from "./BarcodeTest.vue?vue&type=script&lang=js&"
export * from "./BarcodeTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ee241",
  null
  
)

export default component.exports